$(document).ready(function () {
  $('.js-change-reservation-date').on('change', function () {
    var url = $(this).data('url');
    var propertyId = $(this).data('property-id');
    var locale = $(this).data('currency-short-cut');
    var dateFrom = $('.js-date-from');
    var dateTo = $('.js-date-to');
    $.ajax({
      type: 'POST',
      url: url,
      dataType: 'json',
      data: {
        dateFrom: dateFrom.val(),
        dateTo: dateTo.val(),
        propertyId: propertyId,
        locale: locale,
      },
      success: function (data) {
        $('.js-reservation-input-price').html(data.inputView);
        $('.js-property-price').html(data.price);
        $('.js-property-price-text').html(data.priceText);
        $('.js-villa-tax').html(data.taxText);
        $('.js-villa-on-day-price').html(data.oneDayPriceText);
        $('.js-villa-on-day-price-title').html(data.oneDayPriceTextTitle);
        $('.js-villa-bottom-price').html(data.bottomPrice);
      },
    });
  });
});
